export default {
    view_cerebrumx_integration_title: "CerebrumX Integration",
    view_cerebrumx_integration_success_message: "the profile has been updated",
    view_cerebrumx_integration_error_message: "Unable to save the profile due to an error",
    view_cerebrumx_integration_cerebrumX: "CerebrumX",
    view_cerebrumx_integration_diesellaptops: "Diesel Laptops",
    view_cerebrumx_integration_info: "Info",
    view_cerebrumx_integration_thresholds: "Thresholds",
    view_cerebrumx_integration_cerebrumx: "CerebrumX",
    view_cerebrumx_integration_fleet: "Fleet",
    view_cerebrumx_integration_fleet_id: "Fleet Id",
    view_cerebrumx_integration_status: "Status",
    view_cerebrumx_integration_oems: "OEMs",
    view_cerebrumx_integration_harsh_acceleration: "Harsh Acceleration",
    view_cerebrumx_integration_harsh_acceleration_range: "Number must be between 2 and 5",
    view_cerebrumx_integration_harsh_breaking: "Harsh Breaking",
    view_cerebrumx_integration_harsh_breaking_range: "Number must be between -5 and -2",
    view_cerebrumx_integration_harsh_cornering: "Harsh Cornering",
    view_cerebrumx_integration_harsh_cornering_range: "Number must be between 2 and 5",
    view_cerebrumx_integration_overspeeding: "Overspeeding",
    view_cerebrumx_integration_overspeeding_range: "Speed limit must be between 40 - 150 mph",
    view_cerebrumx_integration_idling: "Idling",
    view_cerebrumx_integration_idling_range: "Minimum idling duration should be 60 sec",
    view_cerebrumx_integration_ms_square: "m/s²",
    view_cerebrumx_integration_mph: "mph",
    view_cerebrumx_integration_sec: "sec",
    view_cerebrumx_integration_add_oem: "Add OEM",
    view_cerebrumx_integration_save_profiles: "Save Profiles"



}

